// extracted by mini-css-extract-plugin
export default {"footer":"PriceSelectionFooter_footer__1h3+F","cancelButton":"PriceSelectionFooter_cancelButton__wJocb"};